/* global mapDesc, mapStates, mapUrlPrefix -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
import { initMap } from '@common/components/usmap';
import { failure } from '@common/alert';
import 'slick-carousel';

(function () {
    initMap('home_states_map', mapStates, mapDesc, mapUrlPrefix, 800);

    $(document).ready(function () {

        // Submit FAQ Question
        $(document).on('click', '#submitFaqQuestion', function() {
            const btn = $(this);
            const parsley = $('#home-faq-ask').parsley();

            if (parsley.validate()) {
                btn.attr('disabled', 'disabled');

                const url = btn.data('url');
                const redirect = btn.data('redirect');

                $.post(url, {
                    question: $('#question').val(),
                    category: $('#category').val(),
                }).done((data) => {
                    if (data.status) {
                        location.href = redirect;
                    } else {
                        btn.removeAttr('disabled');
                        failure('An unexpected error occurred, please try again later.');
                    }
                });
            }
        });

        $('#blog-carousel-track').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: '#blog-carousel-prev',
            nextArrow: '#blog-carousel-next',
            dots: true,
            appendDots: '#blog-carousel-indicators',
        });
    });
})();
